import { ReactNode } from 'react';
import { create } from 'zustand';

interface HeaderState {
  // Whether to show the header at all
  showHeader: boolean;
  // Title to show in the header
  title: string;
  // Optional description text
  description?: string;
  // Actions/buttons to render on the right side
  actions: ReactNode | null;
  // Set the header content
  setHeaderContent: (options: {
    title?: string;
    actions?: ReactNode;
    description?: string;
    showHeader?: boolean;
  }) => void;
  // Clear the header content
  clearHeader: () => void;
  // Reset to defaults
  resetHeader: () => void;
}

const useHeaderStore = create<HeaderState>((set) => ({
  showHeader: true,
  title: '',
  description: undefined,
  actions: null,

  setHeaderContent: ({ title, actions, description, showHeader = true }) => 
    set((state) => ({
      title: title ?? state.title,
      actions: actions ?? state.actions,
      description: description ?? state.description,
      showHeader: showHeader ?? state.showHeader,
    })),

  clearHeader: () => set({
    showHeader: false,
    title: '',
    description: undefined,
    actions: null,
  }),

  resetHeader: () => set({
    showHeader: true,
    title: '',
    description: undefined,
    actions: null,
  }),
}));

export default useHeaderStore;
